<template>
  <modal
    ref="modal"
    title="Editar dados"
    :showModal="hasModalIndividualEdit"
    @close="closeModalEdit"
  >
    <template v-slot:body>
      <ValidationObserver
        tag="div"
        class="body"
        ref="form"
        v-slot="{ passes, pristine }"
      >
        <form @input="toggleButtonState(pristine)" @submit.prevent="passes(submitIndividualFormData)">
          <div class="wrapper">
            <div class="section">
              <div class="two-column">
                <input-field
                  placeholder="Nome completo"
                  name="name"
                  rules="required"
                  v-model="individualData.completedName"
                />

                <input-field
                  class="right"
                  placeholder="Data de nascimento"
                  name="date"
                  mask="##/##/####"
                  rules="required"
                  v-model="individualData.birthDate"
                />
              </div>

              <div class="two-column">
                <input-field
                  placeholder="E-mail"
                  name="email"
                  rules="required"
                  v-model="individualData.email"
                />

                <input-field
                  class="right"
                  name="phone"
                  rules="required|phone"
                  :mask="['(##) ####-####', '(##) #####-####']"
                  placeholder="Telefone empresarial"
                  v-model="individualData.phoneNumber"
                />
              </div>
            </div>

            <div class="button-container">
              <button-component
                scale="normal"
                size="large"
                v-ripple="$theme.secondColorDarkTransparent"
                styles="ghost"
                type="button"
                :isDisabled="hasRequest"
                text="Fechar"
                @click.native="closeModalEdit"
              />

              <button-component
                class="right"
                scale="normal"
                size="large"
                v-ripple="$theme.whiteColorTransparent"
                styles="primary"
                :isDisabled="hasRequest || isButtonDisable"
                :hasLoader="hasRequest"
                text="Alterar e salvar"
              />
            </div>
          </div>
        </form>
      </ValidationObserver>
    </template>
  </modal>
</template>

<script>
  import { ValidationObserver } from 'vee-validate';
  import { mapState } from 'vuex';
  import Modal from '@/components/Modal/Base';
  import Button from '@/components/Base/Button';
  import InputField from '@/components/Base/InputField';

  export default {
    name: 'EditIndividualModal',

    data() {
      return {
        hasRequest: false,
        isButtonDisable: true,
        individualData: {
          firstName: '',
          lastName: '',
          completedName: '',
          email: '',
          phoneNumber: '',
          birthDate: '',
          statementDescriptor: '',
          addressLine: '',
          addressNumber: '',
          addressComplement: '',
          addressNeighborhood: '',
          addressCity: '',
          addressState: '',
          addressPostalCode: '',
        },
      };
    },

    components: {
      ValidationObserver,
      'button-component': Button,
      'input-field': InputField,
      'modal': Modal
    },

    computed: {
      ...mapState({
        hasModalIndividualEdit: state => state.hasModalIndividualEdit,
        sellerData: state => state.sellerData,
      })
    },

    watch: {
      sellerData() {
        this.setDefaultIndividualValues();
      },

      hasModalIndividualEdit() {
        this.setDefaultIndividualValues();
      }
    },

    mounted() {
      this.setDefaultIndividualValues();
    },

    methods: {
      async submitIndividualFormData() {
        this.hasRequest = true;

        let formData = JSON.stringify({
          first_name: this.$service.splitFirstName(this.individualData.completedName),
          last_name: this.$service.splitLastName(this.individualData.completedName),
          email: this.individualData.email,
          phone_number: this.$service.removeCharacter(this.individualData.phoneNumber),
          birthdate: this.$service.dateFormat(this.individualData.birthDate, 'DD/MM/YYYY', 'YYYY-MM-DD'),
          statement_descriptor: this.individualData.statementDescriptor,
          address_line1: this.individualData.addressLine,
          address_line2: this.individualData.addressNumber,
          address_line3: this.individualData.addressComplement,
          address_neighborhood: this.individualData.addressNeighborhood,
          address_city: this.individualData.addressCity,
          address_state: this.individualData.addressState,
          address_postal_code: this.$service.removeCharacter(this.individualData.addressPostalCode),
        });

        await this.$store.dispatch('putIndividualSeller', { formData })
          .then(() => {
            this.snackbarNotification('Dados editados com sucesso', '#08B978');
          })
          .catch(() => {
            this.snackbarNotification('Erro ao editar os dados cadastrais', '#FF5A5A');
          });

        this.closeModalEdit();

        await this.$store.dispatch('getSellerId')
          .catch(() => {
            this.snackbarNotification('Erro ao atualizar os dados', '#FF5A5A');
          });

        this.hasRequest = false;
        this.isButtonDisable = true;
      },

      setDefaultIndividualValues() {
        this.individualData.completedName = this.sellerData.first_name + ' ' + this.sellerData.last_name;
        this.individualData.email = this.sellerData.email;
        this.individualData.phoneNumber = this.sellerData.phone_number;
        this.individualData.birthDate = this.$service.dateFormat(this.sellerData.birthdate, 'YYYY-MM-DD', 'DD/MM/YYYY');
        this.individualData.statementDescriptor = this.sellerData.statement_descriptor;
        this.individualData.mcc = this.sellerData.mcc;

        this.individualData.addressLine = this.sellerData.address_line1;
        this.individualData.addressNumber = this.sellerData.address_line2;
        this.individualData.addressComplement = this.sellerData.address_line3;
        this.individualData.addressNeighborhood = this.sellerData.address_neighborhood;
        this.individualData.addressCity = this.sellerData.address_city;
        this.individualData.addressState = this.sellerData.address_state;
        this.individualData.addressPostalCode = this.sellerData.address_postal_code;
      },

      closeModalEdit() {
        this.$store.commit('closeModalEdit');
      },

      toggleButtonState(pristine) {
        this.isButtonDisable = pristine;

        if (this.hasRequest) {
          this.isButtonDisable = true;
        }
      },

      snackbarNotification(text, color) {
        this.$emit('snackbarNotification', text, color);
      }
    }
  };
</script>

<style lang="scss" scoped>
  .modal {
    .body {
      .wrapper {
        margin-top: 1.5rem;

        .section {
          .two-column {
            display: flex;

            .right {
              margin-left: 1rem;
              max-width: 225px;
            }
          }
        }
      }
    }

    .button-container {
      display: flex;
      justify-content: flex-end;

      .right {
        margin-left: 1rem;
        min-width: 156px;
      }
    }
  }

  @media (max-width: 767px) {
    .modal {
      h2 {
        font-size: 16px;
      }
    }
  }

  @media (max-width: 520px) {
    .modal {
      .body {
        .wrapper {
          overflow-y: scroll;
          max-height: 72vh;
          // margin-bottom: 4rem;

          &::-webkit-scrollbar {
            display: none;
          }

          .section {
            .two-column {
              flex-direction: column;

              .right {
                margin-left: 0;
                max-width: initial;
              }
            }

            .column {
              width: 100%;
            }
          }

          .button-container {
            justify-content: center;
          }
        }
      }
    }
  }
</style>